import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/auth.service';

interface AdminRouteProps {
    children: React.ReactElement;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const user = AuthService.getCurrentUser();

    if (!user) {
        // Not logged in -> Redirect to Login
        return <Navigate to="/login" replace />;
    }

    // Check for ROLE_ADMIN or specific admin email as fallback
    // Note: user.roles might be ["ROLE_ADMIN"] or similar. 
    // We also fallback to email check just like in Login.tsx
    const hasAdminRole = user.roles && user.roles.includes('ROLE_ADMIN');
    const isAdminEmail = user.email && user.email.toLowerCase() === 'admin@myft.gr';

    if (!hasAdminRole && !isAdminEmail) {
         // Logged in but not Admin -> Redirect to User Dashboard
        return <Navigate to="/dashboard" replace />;
    }

    // Authorized -> Render the component
    return children;
};

export default AdminRoute;
